import React from "react";

import { useQuery } from "@apollo/client";
import {
  Box,
  Button,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { groupBy } from "lodash";
import { Link, useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";

const clientModulesPageQuery = graphql(`
  query ClientModulesPage($clientId: ID!) {
    learningModuleAnswers(clientId: $clientId, order: DESC) {
      nodes {
        id
        completedAt
        learningModule {
          id
          week
          title
        }
      }
    }
  }
`);

const useStyles = makeStyles()({
  title: {
    fontWeight: 700,
    fontSize: "20px",
    color: "#363E45",
  },
  head: {
    backgroundColor: "#EDF0F5",
  },
  cell: {
    borderBottom: 0,
  },
});

const ClientModulesPage: React.FC = () => {
  const { classes } = useStyles();
  const { clientId } = useParams<{ clientId: string }>();
  const { data } = useQuery(clientModulesPageQuery, {
    variables: { clientId: clientId ?? "" },
  });

  const groupedByWeek = groupBy(
    data?.learningModuleAnswers.nodes,
    "learningModule.week"
  );

  return (
    <Box p="24px" bgcolor="white" mx="10px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography className={classes.title}>Modules</Typography>
        <Select native>
          <option>All</option>
        </Select>
      </Box>
      <Box display="flex" flexDirection="column" gap="40px" mt="16px">
        {Object.entries(groupedByWeek)
          .reverse()
          .map(([week, nodes]) => (
            <Table key={week}>
              <TableHead>
                <TableRow className={classes.head}>
                  <TableCell className={classes.cell} width="50%">
                    Week {week}
                  </TableCell>
                  <TableCell className={classes.cell}>Progress</TableCell>
                  <TableCell className={classes.cell} width="164px">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {nodes.map((node) => (
                  <TableRow key={node.id}>
                    <TableCell className={classes.cell}>
                      <Box fontSize={16} color="#112340">
                        {node.learningModule.title}
                      </Box>
                    </TableCell>
                    <TableCell className={classes.cell}>
                      {node.completedAt ? (
                        <Box fontSize={16} color="#1FD4AF">
                          Completed
                        </Box>
                      ) : (
                        <Box fontSize={16} color="#FF7878">
                          Not completed
                        </Box>
                      )}
                    </TableCell>
                    <TableCell className={classes.cell}>
                      {node.completedAt && (
                        <Button
                          component={Link}
                          to={node.id}
                          variant="outlined"
                          color="inherit"
                        >
                          View Answers
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ))}
      </Box>
    </Box>
  );
};

export default ClientModulesPage;
